export const QUERY_KEYS = {
  company: 'company',
} as const;
